<template>
  <transition name="transition">
    <div
      v-show="opened"
      class="pendencies-images-modal"
    >
      <div class="pendencies-images-modal__content">
        <button
          class="pendencies-images-modal__close-button"
          @click="closeModal"
        >
          <svg
            class="icon"
            viewBox="0 0 24 24"
          >
            <title>Fechar Modal de Imagens das Pendências</title>
            <g
              fill="none"
              stroke="currentColor"
              stroke-miterlimit="10"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line
                x1="3"
                y1="3"
                x2="21"
                y2="21"
              />
              <line
                x1="21"
                y1="3"
                x2="3"
                y2="21"
              />
            </g>
          </svg>
        </button>

        <h5>Pendências</h5>

        <ul
          v-if="pendency"
          class="pendencies-images-modal__list"
        >
          <PendenciesImagesModalContent
            v-for="(imagem, index) in pendency.transmissionFiles"
            :key="index"
            :imagem="imagem"
          />
        </ul>
        <div v-else>
          Você não possui imagens de pendências...
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex'
import PendenciesImagesModalContent from './PendenciesImagesModalContent.vue';

export default {
  name: 'PendenciesImagesModal',
  components: {
    PendenciesImagesModalContent
  },
  data() {
    return {
      pendency: null,
      opened: false
    }
  },
  methods: {
    ...mapActions(['pendencyDownloadTransferedFile']),
    openModal(pendency) {
      this.opened = true
      this.pendency = pendency
    },
    closeModal() {
      this.opened = false
      this.pendency = null
    }
  }
}
</script>

<style lang="scss">
.pendencies-images-modal {
  position: fixed;
  z-index: 1040;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity ease-in 0.2s;
  font-family: 'Exo 2', sans-serif !important;

  &__content {
    width: 650px;
    max-width: 90%;
    height: 600px;
    max-height: 92%;
    background: #fff;
    padding: 18px;
    border-radius: 6px;
    position: relative;
    overflow-y: scroll;
  }

  &__close-button {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1041;
    background-color: #0000006e;
    display: flex;
    flex-shrink: 0;
    border-radius: 50%;
    outline: none;
    transition: all ease 0.2s;
    padding: 0;

    svg {
      display: block;
      margin: auto;
      width: 18px;
      height: 18px;
    }
  }

  &__list {
    img,
    iframe {
      margin-top: 8px;
      width: 100%;
    }
  }

  h5 {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 500;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #7f1a54;
    border-radius: 20px;
    border: 2px solid transparent;
  }
}
</style>
